module.exports = __webpack_public_path__ + "img/red_009.496cb4d7.png";